import { CSSProperties } from "react";
import { Form } from "antd";
import styled from "styled-components";
import theme from "styles/theme";

const { Item } = Form;

export const InputField: CSSProperties = {
  height: theme["@height-button-lg"],
};

export const FormItem = styled(Item)`
  .ant-input {
    margin-left: 0;
    font-size: ${(props) => props.theme["@medium-font-size"]};
  }
  .ant-select-clear {
    right: 30px;
  }

  .ant-form-item-label {
    min-width: 100%;
    max-width: 100%;
    font-family: ${(props) => props.theme["@font-family"]};
    font-weight: ${(props) => props.theme["@bold-font-weight"]};
    font-size: ${(props) => props.theme["@medium-font-size"]};
    padding: 3px 0;
    z-index: 1;
    > label {
      font-family: ${(props) => props.theme["@font-family"]};
      font-weight: ${(props) => props.theme["@bold-font-weight"]};
      font-size: ${(props) => props.theme["@medium-font-size"]};
      pointer-events: none !important;
      :hover {
        pointer-events: none !important;
      }
    }
  }
  .ant-select-single.ant-select-lg:not(.ant-select-customize-input) .ant-select-selector {
    height: ${(props) => props.theme["@height-input-lg"]};
  }

  .ant-select-disabled.ant-select:not(.ant-select-customize-input) .ant-select-selector,
  .ant-input[disabled] {
    background: ${(props) => props.theme["@input-background-disabled"]};
    color: ${(props) => props.theme["@profile-text-color"]};
    cursor: default;
  }

  .ant-input-affix-wrapper-disabled,
  .ant-input-disabled {
    input:-webkit-autofill,
    input:-webkit-autofill:hover,
    input:-webkit-autofill:active,
    input:-webkit-autofill:focus {
      background-color: ${(props) => props.theme["@input-background-disabled"]} !important;
      color: ${(props) => props.theme["@secondary-color"]} !important;
      box-shadow: 0 0 0 1000px ${(props) => props.theme["@input-background-disabled"]} inset !important;
      -webkit-box-shadow: 0 0 0 1000px ${(props) => props.theme["@input-background-disabled"]} inset !important;
    }
    :hover {
      border: 1.6px solid ${(props) => props.theme["@input-border-color"]} !important;
      background-color: ${(props) => props.theme["@input-background-disabled"]} !important;
      cursor: default;
      > input {
        background-color: ${(props) => props.theme["@input-background-disabled"]} !important;
        border: none !important;
      }
    }
  }

  .ant-select-multiple.ant-select-disabled.ant-select:not(.ant-select-customize-input) .ant-select-selector {
    height: 48px;
  }

  .ant-select-single.ant-select-lg:not(.ant-select-customize-input) .ant-select-selector .ant-select-selection-item {
    color: ${(props) => props.theme["@profile-text-color"]};
  }

  .ant-select:not(.ant-select-customize-input) .ant-select-selector:hover {
    background-color: ${(props) => props.theme["@primary-color"]};
  }

  .ant-form-item-required::before {
    content: "" !important;
  }

  .ant-form-item-control {
    width: 100%;
  }

  &.ant-form-item-control-input > button {
    width: 100%;
  }
`;

export const LayoutForm = styled.div`
  width: 100%;
  height: auto;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr;
  grid-row-gap: 0px;
`;

export const FormContainer = styled.div`
  .full-width-tabs .ant-tabs-nav-list {
    display: flex;
    width: 100%;
    margin-top: -18px;
  }

  .full-width-tabs .ant-tabs-tab {
    flex: 1 1 50%;
    max-width: 50%;
    justify-content: center;
  }

  .full-width-tabs .ant-tabs-tab-btn {
    width: 100%;
    text-align: center;
  }
`;

export const FormLayout: CSSProperties = {
  height: "100%",
};

export const Description = styled.div`
  font-size: 16px;
  margin-bottom: 10px;
`;

export const DescriptionFormItem: CSSProperties = {
  width: "100%",
  fontWeight: theme["@bold-font-weight"],
  fontSize: theme["@medium-font-size"],
};

export const SelectField: CSSProperties = {
  color: theme["@default-color"],
  fontFamily: theme["@font-family"],
  height: theme["@height-input-lg"],
};

export const CheckDescription: CSSProperties = {
  maxWidth: "100%",
  fontFamily: theme["@font-family"],
  fontWeight: 600,
  padding: "3px 0",
  zIndex: 1,
  marginRight: "5px",
  fontSize: theme["@medium-font-size"],
};

export const EventsContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  align-items: center;
  justify-content: center;
  margin-right: 70%;
  grid-column-gap: 5px;
  > div {
    display: flex;
    margin-right: 15px;
    gap: 7px;
  }
`;

export const ExcludeContainer = styled.div`
  .btnExclude,
  .ant-btn-exclude {
    height: ${(props) => props.theme["@height-button-lg"]};
    width: 100%;
    margin-top: 15px;
    color: ${(props) => props.theme["@default-background"]};
    font-size: ${(props) => props.theme["@large-font-size"]};
    font-weight: ${(props) => props.theme["@bold-font-weight"]};
    background-color: ${(props) => props.theme["@danger-color"]};
    display: flex;
    align-items: center;
    justify-content: center;
    float: left;
    border: none !important;
    :hover,
    :focus {
      color: ${(props) => props.theme["@default-background"]};
      background-color: ${(props) => props.theme["@danger-color-hover"]} !important;
      border: none;
    }
  }
  .ant-btn-exclude[disabled],
  .ant-btn[disabled],
  .btnExclude[disabled] {
    height: ${(props) => props.theme["@height-button-lg"]};
    width: 100%;
    background-color: ${(props) => props.theme["@muted-background"]} !important;
    border: 1.6px solid ${(props) => props.theme["@muted-background"]} !important;
    color: ${(props) => props.theme["@disabled-button"]} !important;
    display: flex;
    align-items: center;
    justify-content: center;
    float: left;
    border: none !important;
    pointer-events: none;
    cursor: not-allowed;
  }
`;

export const FormCheckbox = styled(Item)`
  .ant-input {
    margin-left: 0;
  }

  .ant-form-item-control {
    width: 100%;
  }

  .ant-input-number {
    width: 100%;
    min-width: 60px;
  }

  &.ant-form-item {
    margin-bottom: 4px;
  }

  .ant-form-item-label {
    min-width: 100%;
    max-width: 100%;
    font-family: ${(props) => props.theme["@font-family"]};
    font-weight: 300;
    padding: 3px 0;
    z-index: 1;
  }

  .ant-form-item-required::before {
    content: "" !important;
  }

  .ant-form-item-control-input-content {
    display: grid;
  }

  .ant-input {
    box-shadow: none;
    &:hover {
      border-color: ${(props) => props.theme["@secondary-color"]};
    }
  }
`;
